var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectionsRun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8404 13C65.8404 17.4 62.2404 21 57.8404 21C53.4404 21 49.8404 17.4 49.8404 13C49.8404 8.6 53.4404 5 57.8404 5C62.2404 5 65.8404 8.6 65.8404 13ZM47.4404 59L45.1604 69C44.2004 73.24 40.0404 75.92 35.8004 75.08L19.3604 71.8C17.2004 71.36 15.8004 69.24 16.2404 67.08V66.92C16.6804 64.76 18.8004 63.36 20.9604 63.8L36.6404 67L43.0404 34.6L35.8404 37.4V47C35.8404 49.2 34.0404 51 31.8404 51C29.6404 51 27.8404 49.2 27.8404 47V37.52C27.8404 34.28 29.7604 31.4 32.7204 30.12L48.6404 23.4C49.2404 23.4 49.7404 23.3 50.2404 23.2C50.7404 23.1 51.2404 23 51.8404 23C54.6404 23 57.0404 24.6 58.6404 27L62.6404 33.4C65.3204 38.12 70.3604 41.72 76.4404 42.72C78.4004 43.04 79.8404 44.68 79.8404 46.64C79.8404 49.08 77.6804 51 75.2804 50.64C68.3204 49.52 62.1204 45.96 57.8404 41L55.4404 53L61.3604 58.64C62.9604 60.16 63.8404 62.24 63.8404 64.44V87C63.8404 89.2 62.0404 91 59.8404 91C57.6404 91 55.8404 89.2 55.8404 87V67L47.4404 59Z",
    fill: "#702F8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionsRun);
export default __webpack_public_path__ + "static/media/directions_run.1a433dfb7fd37dea30b00933dbea5de2.svg";
export { ForwardRef as ReactComponent };